import { OperationType, SettlementType, Ticket } from "./Entity";

export class PublicFixedIncome extends Ticket {
  constructor() {
    super();
  }

  // Dados da operação
  id: number = null;
  operationTypeId: OperationType = null;
  amount: number = null;
  unitPrice: number = null;
  settlementDate: Date = null;
  acquisitionDate: Date = null;
  operationValue: number = null;
  operationDate: Date = null;
  settlementTypeId: SettlementType = null;

  // Dados Carteira/Fundo
  portfolioName = "";
  portfolioCode = "";
  portfolioDocument = "";
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount = "";
  portfolioSelicAccount = "";
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  // Dados do título
  security = "";
  securityId = "";
  expirationDate: Date = null;
  issueTax: number = null;
  issueDate: Date = null;
  securitySourceId: string = null;

  // Dados da Contraparte
  counterpartName = "";
  counterpartDocument = "";
  counterpartSelicAccount = "";
  command = "";

  annotations = "";

  MandatorySettlementDate(): boolean {
    return (
      this.operationTypeId === OperationType.Redemption &&
      this.settlementTypeId === SettlementType.Term
    );
  }
}
